export default __webpack_public_path__ + "static/compareItemImg2-9bb1192d8dab94d70cda585e914b3f8b.webp";